import {getCardType} from '../../selectors/CardOptionSelectors/CardOptionSelectors';
import maxLength from './max-length';
import minLength from './minLength';
import digitsOnly from './digitsOnly';
import store from '../../store/store';

const validCv2ErrorKey = 'errors.formFields.cv2';

const validCv2 = (validationOrigin, isAmex) => (cv2) => {
  const state = store.getState();
  const {settings} = state.start;
    
  if ((validationOrigin === 'stored card' && settings.stored_card_cv2_length_payment_validation_enabled)
    || (validationOrigin === 'new card' && settings.new_card_cv2_length_payment_validation_enabled)) {
    if (!cv2) return;
    
    const cv2Value = cv2.replace(/\s/g, '');
    if (!cv2Value) return validCv2ErrorKey;

    let cv2Length;
    if (validationOrigin === 'stored card') {
      cv2Length = isAmex ? 4 : 3;
    } else {
      cv2Length = getCardType(state).cv2Length;
    }

    const digitsOnlyValidator = digitsOnly();
    const minLengthChecker = minLength(cv2Length || 3, 'cv2');
    const maxLengthChecker = maxLength(cv2Length || 4, 'cv2');

    return digitsOnlyValidator(cv2Value) || minLengthChecker(cv2Value) || maxLengthChecker(cv2Value);
  }

  if (!cv2 || !cv2.match(/^\d{3,4}$/)) {
    return validCv2ErrorKey;
  }
};

export default validCv2;
